import { isBlank } from '@/utils/strings';
import { parseLocaleNumber } from '@/utils/numbers';

export const styles = {
  formControl: {
    m: 1,
    '& input::placeholder': {
      fontStyle: 'italic',
    },
  },
};

export function getPrice(newValue: string, currentValue: string) {
  return isBlank(newValue) || !isNaN(parseLocaleNumber(newValue))
    ? newValue
    : currentValue;
}
